import React from "react";
import Button, { ButtonProps } from "@components/Button";
import { navigate } from "gatsby";

export interface TryMikaButtonProps extends Omit<ButtonProps, "children"> {
  inviteCode?: string;
  buttonText?: string;
  isInfoway?: boolean;
}

const DEFAULT_INVITE_CODE = process.env.GATSBY_DEFAULT_INVITE_CODE || "qGOL7r";

const TryMikaButton = ({
  inviteCode,
  buttonText = "Try Mika Now",
  isInfoway = false,
  ...props
}: TryMikaButtonProps) => {
  const signUpEvent = () => {
    if (window) {
      const defaultInviteCode = inviteCode || DEFAULT_INVITE_CODE;
      const code = window.sessionStorage.getItem("scribeInviteCode");

      if (!code || inviteCode) {
        window.sessionStorage.setItem("scribeInviteCode", defaultInviteCode);
      }

      const finalInviteCode = window.sessionStorage.getItem("scribeInviteCode");

      if ((window as any).dataLayer) {
        (window as any).dataLayer.push({
          event: "scribe-sign-up-cta",
          inviteCode: finalInviteCode
        });
      }
      if (isInfoway) {
        navigate(`/infoway-scribe-signup?code=${finalInviteCode}`);
      } else {
        navigate(`/scribe-signup?code=${finalInviteCode}`);
      }
    }
  };

  return (
    <Button id="tryMikaFree" onClick={signUpEvent} {...props}>
      {buttonText || "Try Mika free!"}
    </Button>
  );
};

export default TryMikaButton;
